const awsExports = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '',
      region: process.env.REACT_APP_AWS_REGION || 'eu-north-1',
    },
  },
};

// Validate required environment variables at startup
const validateEnvironment = () => {
  const required = [
    'REACT_APP_USER_POOL_ID',
    'REACT_APP_USER_POOL_CLIENT_ID',
    'REACT_APP_AWS_REGION',
  ];

  const missing = required.filter(key => !process.env[key]);

  if (missing.length > 0) {
    console.error('Missing required environment variables:');
    missing.forEach(key => console.error(`   - ${key}`));
    console.error('\nPlease check your .env file and ensure all required variables are set.');
    console.error('   See .env.example for reference.');
  }
};

// Run validation in development
if (process.env.NODE_ENV === 'development') {
  validateEnvironment();
}

export default awsExports;

// NOTE: After deploying the SAM template, update your .env file with:
// - REACT_APP_USER_POOL_ID: Get from CloudFormation stack outputs "UserPoolId"
// - REACT_APP_USER_POOL_CLIENT_ID: Get from CloudFormation stack outputs "UserPoolClientId"
// - REACT_APP_AWS_REGION: Should match your deployment region 